<template>
  <base-show :fields="isProvider ? adminFields: makerFields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    return {
      resourceName: "maker_administrators",
      adminFields: [
        [
          {
            label: "メーカーID",
            name: "maker_id",
            long: true
          },
          {
            label: "メーカー名",
            name: "maker_name",
            long: true
          },
          {
            label: "メーカー管理者ID",
            name: "maker_administrator_id",
            long: true
          },
          {
            label: "メーカー管理者名",
            name: "name",
            long: true
          },
          {
            label: "メーカー管理者名（かな）",
            name: "name_kana",
            long: true
          },
          {
            label: "メーカー管理者メールアドレス",
            name: "email",
            long: true
          },
          {
            label: "削除ステータス",
            name: "maker_administrator_deleted",
            optionType: "common/delete_status",
            render(value) {
              if(value !== 0) {
                return vm.optionName("common/delete_status", value);
              }else{
                return "";
              }
            },
            long: true
          },
          {
            label: "契約プラン",
            name: "plan",
            optionType: "common/plans",
            render(value) {
              return vm.optionName("common/plans", value);
            },
            long: true
          }
        ]
      ],
      makerFields: [
        [
          {
            label: "管理者名",
            name: "name",
            long: true
          },
          {
            label: "管理者名（かな）",
            name: "name_kana",
            long: true
          },
          {
            label: "管理者メールアドレス",
            name: "email",
            long: true
          }
        ]
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.isProvider ? "メーカー管理者管理" : "担当者一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: this.isProvider ? "メーカー管理者詳細" : "担当者詳細",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    authAccountId() {
      return this.$store.getters[`auth/accountId`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    }
  }
};
</script>
